import { BigQueryEventName, BigQueryEventProperties } from './bigQuery.types';

export const BIGQUERY_PROPERTIES_MAP: Record<keyof BigQueryEventProperties, string> = {
    funnel: 'feature.name',
    group: 'group',
    reason: 'reason',
    experience: 'experience',
    emailDomain: 'emailDomain',
    codeActivationAttemptsCount: 'identification.codeActivationAttemptsCount',
};

const IDENTIFICATION_EMBEDDED_PROPERTIES: Partial<BigQueryEventProperties> = {
    group: 'identification flow',
    experience: 'Identification',
};

export const BIGQUERY_EMBEDDED_PROPERTIES: Partial<Record<BigQueryEventName, Partial<BigQueryEventProperties>>> = {
    'identification.activation.show': IDENTIFICATION_EMBEDDED_PROPERTIES,
    'identification.activation.submit': IDENTIFICATION_EMBEDDED_PROPERTIES,
    'identification.activation.completed': IDENTIFICATION_EMBEDDED_PROPERTIES,
    'identification.activation.failed': IDENTIFICATION_EMBEDDED_PROPERTIES,
    'identification.activation.resend_code': IDENTIFICATION_EMBEDDED_PROPERTIES,
    'identification.activation.skip': IDENTIFICATION_EMBEDDED_PROPERTIES,
    'identification.change_email.show': IDENTIFICATION_EMBEDDED_PROPERTIES,
    'identification.change_email.submit': IDENTIFICATION_EMBEDDED_PROPERTIES,
    'identification.change_email.completed': IDENTIFICATION_EMBEDDED_PROPERTIES,
    'identification.change_email.failed': IDENTIFICATION_EMBEDDED_PROPERTIES,
};
